var r = Object.defineProperty, b = Object.defineProperties;
var g = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, S = Object.prototype.propertyIsEnumerable;
var n = (e, i, t) => i in e ? r(e, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[i] = t, l = (e, i) => {
  for (var t in i || (i = {}))
    u.call(i, t) && n(e, t, i[t]);
  if (d)
    for (var t of d(i))
      S.call(i, t) && n(e, t, i[t]);
  return e;
}, m = (e, i) => b(e, g(i));
import { jsx as a, jsxs as c } from "react/jsx-runtime";
import { components as h } from "react-select";
import { Option as o, LeftWrapper as O, SingleValueImage as f, OptionLabel as k } from "./style.es.js";
import { EditableForm as C } from "../../EditableForm/EdidatableForm.es.js";
import { Checkbox as x } from "../../Option/Checkbox.es.js";
import { Icon as P } from "../../../DataDisplay/Icon/Icon.es.js";
import { Radio as _ } from "../../Option/Radio.es.js";
function w(e) {
  var i, t;
  return (i = e.data) != null && i.__isNew__ ? /* @__PURE__ */ a(h.Option, l({}, e)) : /* @__PURE__ */ a(h.Option, m(l({}, e), { children: e.isMulti ? /* @__PURE__ */ c(o, { hasSlideAnimation: ((t = e == null ? void 0 : e.label) == null ? void 0 : t.length) >= 35, children: [
    /* @__PURE__ */ c(O, { children: [
      /* @__PURE__ */ a(x, { checked: e.isSelected }, e.isSelected),
      e.data.image && /* @__PURE__ */ a(f, { src: e.data.image, width: 44, height: 44 })
    ] }),
    /* @__PURE__ */ a(k, { children: /* @__PURE__ */ a("span", { children: e.label }) })
  ] }) : e.selectProps.simple ? /* @__PURE__ */ a(
    C,
    {
      value: e.label,
      editable: e.selectProps.editable,
      onClick: !e.selectProps.editable && e.selectProps.onCancel,
      onEditClick: () => {
        e.data.onEditClick(e.data);
      },
      endButton: e.isSelected && /* @__PURE__ */ a(P, { name: "success", color: "var(--color-accent-primary-default)" })
    },
    e.isSelected
  ) : /* @__PURE__ */ c(o, { children: [
    /* @__PURE__ */ a(_, { id: e.getValue(), checked: e.isSelected }, e.isSelected),
    e.data.image && /* @__PURE__ */ a(f, { src: e.data.image, width: 44, height: 44 }),
    e.label
  ] }) }));
}
w.displayName = "Option";
export {
  w as Option
};
//# sourceMappingURL=Option.es.js.map
